
import { Box, Divider, Grid, Typography, Tooltip, Autocomplete, TextField, InputAdornment, useTheme, Button, Toolbar } from "@mui/material";

import { styled } from '@mui/material/styles';

import { useState, useEffect } from "react";
import Cancel from '@mui/icons-material/CancelOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import PropTypes from 'prop-types';
import Header from "../../../Layout/Header";
import 'dayjs/plugin/customParseFormat';
import CallAlertBar from "../../../Layout/Alertbar";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}





const AddNewStore = ({ handlecallback, editStoreID }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Parent Roll  Alert Values
  const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
  const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
  const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
  const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

  // List of Parameter  
  const [storeName, setStoreName] = useState('');
  const [storeAddress, setStoreAddress] = useState('');
  const [storeNotes, setStoreNotes] = useState('');
  const [storeStatus, setStoreStatus] = useState('');

  const [storeCode, setStoreCode] = useState('');
  const [isStoreCodeLoaded, setIsStoreCodeLoaded] = useState(false);

  const [selectedButtonName, setSelectedButtonName] = useState('');
  const statusOptions = ['Active', 'Inactive'];




  const callback = () => {
    handlecallback();
  }

  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
  ))({
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: colors.blueAccent[500],
      color: 'white',
      fontSize: '14px',
      borderRadius: '10px',
      padding: '10px',

    },
    [`& .MuiTooltip-arrow`]: {
      color: colors.blueAccent[500],
    },
  });




  // call load detail based on edit mode

  useEffect(() => {

    if (editStoreID !== 0) {
      let company_id = localStorage.getItem('companyid');
      const para = { p_companyid: company_id, p_plantid: 1, p_id_store: editStoreID, }

      callApi(API_ENDPOINTS.STORE_GET_DETAIL, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setStoreCode(data[0].store_code);
            setStoreName(data[0].name);
            setStoreAddress(data[0].address);
            setStoreNotes(data[0].notes);
            setStoreStatus(data[0].status);
          }
        })
        .catch(error => { callMessage('error', error.message, 'Error'); });

    }

  }, [editStoreID]);












  useEffect(() => {
    if (!isStoreCodeLoaded) {
      if (editStoreID === 0) {

        let company_id = localStorage.getItem('companyid');
        const para = { p_companyid: company_id, p_plantid: 1, }

        callApi(API_ENDPOINTS.STORE_GET_STORE_NUMBER, 'POST', { 'Content-Type': 'application/json' }, para)
          .then(data => { if (data && data.length > 0) { setStoreCode(data[0].store_code); } })
          .catch(error => { callMessage('error', error.message, 'Error'); });

      }
      else {
        setStoreCode(editStoreID);

      }
    }
  }, [isStoreCodeLoaded]);


  const handleSaveAndDraft = async () => {
    try {
      let company_id = localStorage.getItem('companyid');
      let selectedmode = editStoreID === 0 ? 0 : 1;
      let id_store = editStoreID === 0 ? 0 : editStoreID;

      // Validation checks
      if (!company_id) {
        callMessage('warning', 'Company ID is required', 'Validation');
        return;
      }

      if (!storeCode || storeCode.trim() === '') {
        callMessage('warning', 'Godown Code is required', 'Validation');
        return;
      }
      if (!storeName || storeName.trim() === '') {
        callMessage('warning', 'Godown Name is required', 'Validation');
        return;
      }

      if (!storeAddress || storeAddress.trim() === '') {
        callMessage('warning', 'Godown Address is required', 'Validation');
        return;
      }
      if (!storeStatus || storeStatus.trim() === '') {
        callMessage('warning', 'Status is required', 'Validation');
        return;
      }

      const requestBody = {
        p_companyid: company_id,
        p_plantid: 1,
        p_id_store: id_store,
        p_store_code: storeCode.trim(),
        p_name: storeName.trim(),
        p_address: storeAddress.trim(),
        p_notes: storeNotes.trim(),
        p_mode: selectedmode,
        p_status: storeStatus,
      };

      const data = await callApi(API_ENDPOINTS.STORE_GRUD_PROCESS, 'POST', { 'Content-Type': 'application/json' }, requestBody);

      if (data && data.length > 0) {
        let msg = editStoreID === 0 ? 'New Godown Added Successfully' : 'Godown details updated Successfully';
        callMessage('info', msg, 'info');
      } else {
        callMessage('error', 'Unexpected API response', 'Error');
      }
    } catch (error) {
      callMessage('error', error.message || 'Something went wrong', 'Error');
    }
  };


  const callMessage = (serverityval, msg, title) => {
    setParentRollSeverityvalue(serverityval);
    setParentRollMessageValue(msg);
    setParentRollAlertTitleValue(title);
    setParentRollMsgOpen(true);
  };


  return (<>


    <Box padding={0}>

      <Header title={editStoreID == 0 ? 'New Godown' : 'Edit Godown'} subtitle="" callback={callback} />
      <Divider />

   
      {/* {editStoreID > 0 && (
        <>
          <PurchaseReceiveActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} />
          <Divider />
        </>
      )} */}

      <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />

   <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          px: 1,
          py: 1
        }}
      >
        <Typography variant="h6"  >
          <span style={{ color: 'red' }}>*</span> Mandatory fields
        </Typography>
      </Box>
      
      <Box
        sx={{
          padding: "5px",
          borderRadius: "10px",
          maxHeight: {
            xs: '72vh', // Extra small devices (phones)
            sm: '72vh', // Small devices (tablets)
            md: '74vh', // Medium devices (small laptops)
            lg: '74vh', // Large devices (desktops)
            xl: '82vh', // Extra large devices (large desktops)
          },
          overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: colors.primary[400],
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: colors.blueAccent[600],
            borderRadius: '10px',
            '&:hover': {
              background: colors.blueAccent[800],
            },
          },
          '&::-webkit-scrollbar-corner': {
            background: colors.primary[700],
          }
        }}>

        <Grid container  >



          <Grid item xs={12} xl={12} >

            <Grid container padding="5px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
              <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Godown No # <span style={{ color: 'red' }}>*</span>
                </Typography>
              </Grid>

              <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                <TextField value={storeCode} fullWidth size="small" label="" required variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <CustomTooltip
                          title={
                            <span>
                              <b>click here to enable or disable auto generation of purchase order number.</b> <br />
                            </span>}
                        >
                          <SettingsIcon style={{ fontSize: "20px" }} />
                        </CustomTooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={11} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center" >
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Name <span style={{ color: 'red' }}>*</span>
                </Typography>
              </Grid>

              <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                <TextField fullWidth type="text" size="small" value={storeName} onChange={(e) => { setStoreName(e.target.value) }} />
              </Grid>

            </Grid>
          </Grid>

          <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={11} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center" >
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Address <span style={{ color: 'red' }}>*</span>
                </Typography>
              </Grid>

              <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                <TextField fullWidth type="text" size="small" value={storeAddress} onChange={(e) => { setStoreAddress(e.target.value) }} />
              </Grid>

            </Grid>
          </Grid>
          <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={11} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center" >
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Status <span style={{ color: 'red' }}>*</span>
                </Typography>
              </Grid>

              <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                <Autocomplete
                  fullWidth
                  options={statusOptions}
                  value={storeStatus}
                  onChange={(event, newValue) => {
                    setStoreStatus(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                />
              </Grid>

            </Grid>
          </Grid>



          <Grid item xs={12} lg={12} xl={12} mt={1} padding={2} >
            <Box padding={1} sx={{
              display: 'flex',
              alignItems: 'center',
              borderColor: 'divider',
              borderRadius: 2,
              color: 'text.secondary', '& svg': { m: 1, },
            }} >
              <Grid container spacing={0}>
                <Grid item xs={6} lg={6.4} xl={6} marginRight={1}>
                  <Typography variant="h5" fontWeight="bold">Notes  </Typography>
                  <Grid item xs={12} lg={12} xl={10}>
                    <TextField
                      id="outlined-multiline-static"
                      value={storeNotes}
                      onChange={(e) => setStoreNotes(e.target.value)}
                      //   placeholder="Enter the customer notes , will appear the purchase order."
                      multiline
                      rows={4}
                      fullWidth
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Grid container>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
          <Box position="fixed" sx={{ top: 'auto', bottom: 0 }}>
            <Toolbar>
              <Button size="small" variant="contained" color="secondary" onClick={handleSaveAndDraft} startIcon={<SaveAltIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Save</Button>
              <Button size="small" variant="contained" style={{ backgroundColor: "maroon" }} startIcon={<Cancel />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Cancel</Button>
            </Toolbar>
          </Box>
        </Grid>
      </Grid>

    </Box>

  </>)
}
export default AddNewStore;